import type { Dataset } from '../contract'

export const datasetIsControlledByDataSource = (dataset: Dataset): boolean => {
  return dataset.config.type === 'widget'
}
